import { createStyles, makeStyles } from '@material-ui/core';

const useStyles = makeStyles(() =>
  createStyles({
    container: {
      justifyContent: 'center',
      padding: '0px!important',
      width: '100%',
      maxWidth: 680,
    },
    gridLogo: {
      marginTop: '15px!important',
    },
    logo: {
      width: 165,
    },
    loginTitle: {
      width: '100%',
      color: '#a51814',
      fontWeight: 'normal',
    },
    gridForm: {
      padding: '0 30px',
    },
    form: {
      width: '100%',
    },
    gridInputText: {
      borderColor: '#fbedec!important',
      backgroundColor: '#ffffff',
      border: '1px solid',
      borderRadius: '10px!important',
      padding: '6px 15px!important',
      margin: '5px 0!important',
      height: '3.5em!important',
      width: '100%',
      display: 'flex',
      alignItems: 'center',
    },
    inputText: {
      margin: '5px 0!important',
      padding: '6px 15px!important',
      height: '3.5em!important',
      width: '100%',
    },
    labelText: {
      fontSize: 15,
      marginTop: 5,
      marginBottom: -8,
      fontWeight: 550,
      color: '#a51713',
    },
    btnSubmit: {
      margin: '10px 0!important',
      textTransform: 'uppercase',
      backgroundColor: '#a51713!important',
      width: '100%',
      borderRadius: '10px!important',
    },
    iconSave: {
      marginLeft: 10,
    },
    iconAdd: {
      marginRight: 10,
    },
    gridIconLocation: {
      width: 40,
      height: 68,
      justifyContent: 'center',
      alignItems: 'center',
      display: 'flex',
      borderBottom: '#f5f5f5 solid 1px!important',
    },
    gridTextAddressList: {
      justifyContent: 'center',
      alignItems: 'center',
      textAlign: 'left',
      padding: 10,
      borderBottom: '#f5f5f5 solid 1px!important',
    },
    textDesAddress: {
      margin: 0,
      color: '#363a3e',
    },
    textDescriptionAddress: {
      margin: 0,
      fontSize: 13,
      color: '#bebebe',
    },
    gridIconDelete: {
      width: '35px!important',
      height: '40px!important',
      flexBasis: '35px!important',
      backgroundColor: '#a51713',
      borderRadius: 8,
      justifyContent: 'center',
      alignItems: 'center',
      display: 'flex',
      margin: 15,
      cursor: 'pointer',
    },
    btnNewAddress: {
      width: '100%',
      backgroundColor: '#a51713!important',
      borderRadius: '10px!important',
      margin: '0 15px!important',
      bottom: 85,
      maxWidth: 360,
    },
    btnCancel: {
      margin: '10px 0!important',
      width: '100%',
      color: '#484b50!important',
      fontSize: '12px!important',
    },
    btnCloseModal: {
      margin: '10px 0!important',
      backgroundColor: '#fbd3d3!important',
      width: '100%',
      color: '#000!important',
      borderRadius: '10px!important',
    },
    titleModal: {
      margin: '10px 0 0 0!important',
      textTransform: 'uppercase',
    },
    textModal: {
      textAlign: 'center',
      marginBottom: '15px!important',
      margin: '0px!important',
      padding: '0px 10px',
      fontSize: '14px!important',
      color: '#a8a8a8',
    },
    iconModal: {
      width: 80,
      height: 80,
    },
    content: {
      marginBottom: '-19px!important',
    },
    title: {
      zIndex: 2,
      backgroundColor: '#a51614',
      textTransform: 'uppercase',
      fontWeight: 400,
      padding: '12px 0',
      color: '#fff',
      borderTopLeftRadius: 15,
      borderTopRightRadius: 15,
      height: 50,
      width: '100%',
    },
    gridNameCity: {
      zIndex: 2,
      backgroundColor: '#fff',
      cursor: 'pointer',
      width: '100%',
      padding: '0 20px',

      justifyContent: 'space-between!important',
    },
    nameCity: {
      margin: 0,
      color: '#4d5055',
      fontSize: 18,
    },

    gridButtonLocation: {
      position: 'absolute',
      width: '100%',
      maxWidth: 680,
      top: 19,
    },
    buttonLocation: {
      right: 0,
      float: 'right',
      zIndex: 10,
    },
    contentDesAddressMap: {
      width: '100%',
      maxWidth: 680,
      justifyContent: 'center',
      position: 'absolute',
      display: 'flex',
      zIndex: 10,
    },
    gridDesAddressMap: {
      width: '85%',
      textAlign: 'left',
      background: '#fff',
      marginTop: 10,
      fontSize: 14,
      color: '#646161',
      borderRadius: 5,
      padding: 5,
      border: 'solid 1px #e1d4d4',
    },
    textDesAddressMap: {
      margin: '0px!important',
    },
  }),
);

export default useStyles;
